/** @format */

import React, { useState, useEffect, useRef } from "react";
import banner_career from "../../../assets/banner_career.webp";
import { datacomment, dataService } from "../../../models/mockdata";
import { CardComment } from "../../../components";
import { useLocation } from "react-router-dom";
import { Icon } from "@iconify/react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
// import imglogo from "../../../assets/common/logo.png";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

// import required modules
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import { useTranslation } from "react-i18next";
const Career = () => {
  const { t } = useTranslation();
  const { state } = useLocation();
  const { targetId } = state || {};
  const serviceRef_1 = useRef(null);
  const serviceRef_2 = useRef(null);
  const serviceRef_3 = useRef(null);
  const handleScrollToRef = (ref) => {
    if (ref.current) {
      ref.current.scrollIntoView({
        behavior: "smooth",
      });
    }
  };
  const fadeInUp = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0 },
  };
  const zoomIn = {
    hidden: { opacity: 0, scale: 0.5 },
    visible: { opacity: 1, scale: 1 },
  };
  const fadeIn = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
  };

  const { ref: imgRef } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  useEffect(() => {
    if (targetId === "service_1") {
      handleScrollToRef(serviceRef_1);
    } else if (targetId === "service_2") {
      handleScrollToRef(serviceRef_2);
    } else if (targetId === "service_3") {
      handleScrollToRef(serviceRef_3);
    }
  }, [targetId]);
  const [visibleSlide, setVisibleSlide] = useState(3);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setVisibleSlide(1);
      } else {
        setVisibleSlide(2);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);

    // Cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div>
      <div className="">
        <div className="w-full  h-[calc(100vh-132px)]  relative transition-all duration-1000 ease-in-out">
          <img
            className="w-full h-full absolute  object-cover  top-0 left-0"
            src={banner_career}
          ></img>
        </div>
      </div>

      <motion.div
        initial="hidden"
        animate="visible"
        variants={fadeInUp}
        transition={{ duration: 0.3, delay: 0.3 }}
        className={
          "max-w-[1140px] mx-auto grid lg:grid-cols-2 gap-4 py-[100px] qhd:py-[150px] qhd:max-w-[60%] pvmax:max-dv:w-[85%] pb-[100px]"
        }
      >
        <div className={"w-full flex flex-col "}>
          <p
            className="uppercase pv:max-md:text-4xl lg:pr-4 qhd:text-[2.5rem] text-[2.5rem] text-6xl pb-[1.25rem] text-primary"
            style={{
              lineHeight: 1.25,
              // fontSize: "2.5rem",
              paddingBottom: "1.25rem",
            }}
          >
            {t("careerSubtitle")}
          </p>
        </div>
        <div>
          <p
            className="text-[1rem]  qhd:text-[1rem] text-justify text-primary"
            style={{ lineHeight: 1.6 }}
          >
            {t("careercontent")}
          </p>
        </div>
      </motion.div>
    </div>
  );
};

export default Career;
